import { DataTable, Heading } from "@/components";
import useEmployeeMgmt from "./useEmployeeMgmt";
import { Button, Card } from "@/components/ui";
import { Outlet } from "react-router-dom";
import { filter } from "@/assets";
import { Filter } from "./Filter";

const EmployeeMgmt = () => {
  const {
    columns,
    onAdd,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    tableData,
    onRowClick,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
  } = useEmployeeMgmt();

  return (
    <div className="p-7">
      <Heading title="Employee Management" />

      <Card className="py-5 pt-0 mt-6 shadow-none">
        <div className="mt-5 px-5 flex justify-end gap-3">
          <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
            <img src={filter} />
            Filter
          </Button>
          <Button onClick={onAdd}>+ Add New</Button>
        </div>
        <DataTable
          columns={columns}
          data={tableData}
          onRowClick={onRowClick}
          serviceSidePagination
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
        />
      </Card>
      <Outlet />
      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      )}
    </div>
  );
};

export default EmployeeMgmt;
